import { __assign, __extends, __values } from "tslib";
import { getStacktrace, isError } from "./error";
import { Serializable } from "./serializable";
import { toHashMapString } from "./hashmap";
var Span = (function (_super) {
    __extends(Span, _super);
    function Span(span) {
        return _super.call(this, __assign({ timestamp: Math.round(new Date().getTime() / 1000), namespace: "frontend", error: {
                name: "NullError",
                message: "No error has been set",
                backtrace: []
            } }, span)) || this;
    }
    Span.prototype.setAction = function (name) {
        if (!name || typeof name !== "string") {
            return this;
        }
        this._data.action = name;
        return this;
    };
    Span.prototype.getAction = function () {
        return this._data.action;
    };
    Span.prototype.setNamespace = function (name) {
        if (!name || typeof name !== "string") {
            return this;
        }
        this._data.namespace = name;
        return this;
    };
    Span.prototype.getNamespace = function () {
        return this._data.namespace;
    };
    Span.prototype.setError = function (error) {
        if (!error || !isError(error))
            return this;
        this._data.error = {
            name: error.name || "[unknown]",
            message: error.message,
            backtrace: getStacktrace(error)
        };
        return this;
    };
    Span.prototype.getError = function () {
        return this._data.error;
    };
    Span.prototype.setTags = function (tags) {
        this._data.tags = __assign(__assign({}, this._data.tags), toHashMapString(tags));
        return this;
    };
    Span.prototype.getTags = function () {
        var _a;
        return (_a = this._data.tags) !== null && _a !== void 0 ? _a : {};
    };
    Span.prototype.setParams = function (params) {
        this._data.params = __assign(__assign({}, this._data.params), params);
        return this;
    };
    Span.prototype.getParams = function () {
        var _a;
        return (_a = this._data.params) !== null && _a !== void 0 ? _a : {};
    };
    Span.prototype.setBreadcrumbs = function (breadcrumbs) {
        this._data.breadcrumbs = breadcrumbs;
        return this;
    };
    Span.prototype.getBreadcrumbs = function () {
        var _a;
        return (_a = this._data.breadcrumbs) !== null && _a !== void 0 ? _a : [];
    };
    Span.prototype.setEnvironment = function (environment) {
        this._data.environment = __assign(__assign({}, this._data.environment), environment);
        return this;
    };
    Span.prototype.getEnvironment = function () {
        var _a;
        return (_a = this._data.environment) !== null && _a !== void 0 ? _a : {};
    };
    Span.prototype.cleanBacktracePath = function (matchBacktracePaths) {
        if (matchBacktracePaths.length === 0) {
            return this;
        }
        if (!this._data.error || !this._data.error.backtrace) {
            return this;
        }
        var linesMatched = 0;
        this._data.error.backtrace = this._data.error.backtrace.map(function (line) {
            var e_1, _a;
            var path = extractPath(line);
            if (!path) {
                return line;
            }
            try {
                for (var matchBacktracePaths_1 = __values(matchBacktracePaths), matchBacktracePaths_1_1 = matchBacktracePaths_1.next(); !matchBacktracePaths_1_1.done; matchBacktracePaths_1_1 = matchBacktracePaths_1.next()) {
                    var matcher = matchBacktracePaths_1_1.value;
                    var relevantPath = matcher(path);
                    if (!relevantPath) {
                        continue;
                    }
                    linesMatched++;
                    return line.replace(path, relevantPath);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (matchBacktracePaths_1_1 && !matchBacktracePaths_1_1.done && (_a = matchBacktracePaths_1.return)) _a.call(matchBacktracePaths_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return line;
        });
        if (linesMatched > 0) {
            this.setEnvironment({
                backtrace_paths_matched: linesMatched.toString()
            });
        }
        return this;
    };
    return Span;
}(Serializable));
export { Span };
export function toBacktraceMatcher(regexp) {
    return function (path) {
        var match = path.match(regexp);
        if (!match || match.length < 2) {
            return;
        }
        return match.slice(1).join("");
    };
}
function extractPath(backtraceLine) {
    var _a, _b, _c, _d;
    var IS_CHROME = /^\s*at\s/;
    var CHROME_PATH_WITH_FUNCTION_NAME = /^\s*at(?:\s[^\(]+)?\s\((.*):\d+:\d+\)$/;
    var CHROME_PATH_WITHOUT_FUNCTION_NAME = /^\s*at\s(.*):\d+:\d+$/;
    if (backtraceLine.match(IS_CHROME)) {
        return ((_b = (_a = backtraceLine.match(CHROME_PATH_WITH_FUNCTION_NAME)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : (_c = backtraceLine.match(CHROME_PATH_WITHOUT_FUNCTION_NAME)) === null || _c === void 0 ? void 0 : _c[1]);
    }
    var IS_SAFARI_FF = /^.*@/;
    var SAFARI_FF_PATH = /^.*@\s?(.*):\d+:\d+$/;
    if (backtraceLine.match(IS_SAFARI_FF)) {
        return (_d = backtraceLine.match(SAFARI_FF_PATH)) === null || _d === void 0 ? void 0 : _d[1];
    }
}
//# sourceMappingURL=span.js.map